import PDFViewer from "pdf-viewer-reactjs";
import pdfFile from "../../assets/images/summary-data.pdf";
import melurPdf from "../../assets/images/melur-inventory-data.pdf";
import dindugulPdf from "../../assets/images/dindigul-inventory-data.pdf";
import theniPdf from "../../assets/images/theni-inventory-data.pdf";
import surandaiPdf from "../../assets/images/SRD-Inventory-data.pdf";
import virudhunagarPdf from "../../assets/images/Virudhunagar-Inventory-data.pdf";
import cudalorePdf from "../../assets/images/cuddalor-Inventory-data.pdf";
import kuzhithuraiPdf from "../../assets/images/kuzhithurai-inventory-data.pdf";
import vkpuramPdf from "../../assets/images/vkpuram-inventory-data.pdf";
import ranipetPdf from "../../assets/images/ranipet-inventory-data.pdf";
import puliyangudiPdf from "../../assets/images/Puliyangudi-inventory-data.pdf";
import kayalpattinamPdf from "../../assets/images/kayalpattinam-inventory-data.pdf";
import satturPdf from "../../assets/images/sattur-inventory-data.pdf";
import { useEffect, useRef } from "react";
import "../../styles/summary-inventory.scss";

const cityPdfMap = {
  Tiruvallur:        { pdf: pdfFile,          scale: 8.5 },
  Sattur:            { pdf: satturPdf,        scale: 4 },
  Kayalpattinam:     { pdf: kayalpattinamPdf, scale: 9   },
  Puliyangudi:       { pdf: puliyangudiPdf,   scale: 7   },
  Ranipet:           { pdf: ranipetPdf,        scale: 8.5 },
  Surandai:          { pdf: surandaiPdf,       scale: 6   },
  Viruthunagar:      { pdf: virudhunagarPdf,   scale: 9.3 },
  Cuddalore:         { pdf: cudalorePdf,       scale: 6  },
  Dindigul:          { pdf: dindugulPdf,       scale: 3.5 },
  Melur:             { pdf: melurPdf,          scale: 6   },
  Vikramasingapuram: { pdf: vkpuramPdf,        scale: 12  },
  Kuzhithurai:       { pdf: kuzhithuraiPdf,    scale: 12  },
  Theni:             { pdf: theniPdf,          scale: 3.5 },
};

function getCity() {
  const configResponse = localStorage.getItem("firebaseConfigApiResponse");
  if (!configResponse) return "";
  return JSON.parse(configResponse)?.displayName || "";
}

export default function SummaryInventory() {
  const city = getCity();
  const cityData = cityPdfMap[city];
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!wrapperRef.current) return;

    // pdf-viewer-reactjs sets inline height:1000px and overflow:auto on its root div
    // We use a MutationObserver to catch it even after async render
    const observer = new MutationObserver(() => {
      const allDivs = wrapperRef.current.querySelectorAll("div");
      allDivs.forEach((div) => {
        if (div.style.height === "1000px") {
          div.style.height = "100%";
        }
        if (div.style.overflow === "auto") {
          div.style.overflow = "visible";
        }
      });
    });

    observer.observe(wrapperRef.current, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => observer.disconnect();
  }, [cityData]);

  return (
    <div className="summary-inventory-page">
      <h2 className="summary-inventory-header">Summary Inventory</h2>

      {cityData ? (
        <div className="summary-table-wrapper" ref={wrapperRef}>
          <PDFViewer
            document={{ url: cityData.pdf }}
            scale={cityData.scale}
            hideNavbar
            hideRotation
          />
        </div>
      ) : (
        <p className="summary-no-data">
          Sorry, there is no summary data available to display.
        </p>
      )}
    </div>
  );
}